<div class="art-box">
  <a (click)="onClick()">
    <h4 [innerHTML]="title">{{ title | translate }}</h4>
  </a>
</div>
